import React, { useEffect, useState } from "react";
import { Navigate, useParams, Link } from "react-router-dom";
import MainLayout from "../../layouts/mainLayout";
import VoyageService from "../../services/voyageService";
import VoyageActivitiesComponent from "../../components/voyageReporting/voyageActivitiesComponent";
import Tabs from "../../utils/tabs";
import PayloadUpdater from "../../utils/payloadUpdater";
import Select from "react-select";
import FileInput from "../../components/fileInput";
import Spinner from "../../utils/spinner";
import {
  Validator,
  ValidateGroup,
  ClearValidator,
} from "../../components/validator";
import toastr from "../../utils/toastr";
import ReactTooltip from "react-tooltip";
import CustomModal from "../../utils/customModal";
import {
  camelizeKeys,
  toReadableDate,
  checkUserPermission,
} from "../../utils/utilityFunctions";
import { forEach } from "lodash";
import moment from "moment";

export default function VoyageActivitiesPage() {
  const params = useParams();
  const [redirectUrl, setRedirectUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const [payload, setPayload] = useState({});
  const [saving, setSaving] = useState(false);
  const [voyage, setVoyage] = useState([]);
  const _userRoles = JSON.parse(localStorage.resu)?.roles;

  useEffect(async () => {
    setLoading(true);
    await init();
    await retrieveVoyage();
    setLoading(false);
  }, [params.voyagePlanningId]);

  const init = async () => { };

  const retrieveVoyage = async () => {
    const _voyage = await VoyageService.get(params.voyagePlanningId);
    setVoyage(camelizeKeys(_voyage) || []);
  };

  const tabHeaders = [
    { icon: "icon ni ni-view-grid-wd", text: "Voyage Activities" },
  ];

  const tabContent = [
    <VoyageActivitiesComponent
      voyagePlanningId={params.voyagePlanningId}
      voyage={voyage}
    />,
  ];

  const _tabView = (
    <Tabs headers={tabHeaders} contents={tabContent} contentPadding="3" />
  );

  const finalizedVoyageStages = () => {
    if (
      voyage.voyagePlanningStatus === "Finalized" ||
      voyage.voyagePlanningStatus === "CostAllocated" ||
      voyage.voyagePlanningStatus === "Invoiced"
    )
      return true;
    else return false;
  };

  const pageActions = (
    <div className="toggle-wrap nk-block-tools-toggle">
      <a
        href="#"
        className="btn btn-icon btn-trigger toggle-expand mr-n1"
        data-target="pageMenu"
      >
        <em className="icon ni ni-menu-alt-r" />
      </a>
      <div className="toggle-expand-content" data-content="pageMenu">
        <ul className="nk-block-tools g-3">
          {finalizedVoyageStages() ? null : (
            <li>
              {checkUserPermission("voyage-planning_add_activity") && (
                <Link
                  to={`/add-activity/${params.voyagePlanningId}`}
                  className="btn btn-white btn-outline-light btn-sm"
                >
                  <em className="icon ni ni-plus" />
                  <span>Add Voyage Activity</span>
                </Link>
              )}
            </li>
          )}

          <li>
            <Link
              to="/list-vessels"
              className="btn btn-white btn-outline-light  btn-sm"
            >
              <em className="icon ni ni-arrow-left" />
              <span>Back to Vessels</span>
            </Link>
          </li>

          {_userRoles &&
            _userRoles?.filter((role) => role.Name == "Vessel Master").length !==
            0 ? null : (
            <li>
              <Link to="/voyages" className="btn btn-white btn-outline-light  btn-sm">
                <em className="icon ni ni-arrow-left" />
                <span>Back to Voyages</span>
              </Link>
            </li>
          )}
        </ul>
      </div>
    </div>
  );

  return redirectUrl ? (
    <Navigate to={redirectUrl} replace={true} />
  ) : (
    <MainLayout
      title={
        voyage.vesselName == null
          ? <span style={{ fontSize: "1.3rem" }}>Voyage Activities</span>
          : <span style={{ fontSize: "1.3rem" }}>Voyage Activities: <span style={{ fontWeight: "normal" }}>{voyage.vesselName}/{voyage.voyageCode}</span></span>
      }
      pageActions={pageActions}
      loading={loading}
      showFullLoader={loading}
    >
      <div className="">{_tabView}</div>
    </MainLayout>
  );
}
